import { render, staticRenderFns } from "./SetLocation.vue?vue&type=template&id=5cf7d307"
import script from "./SetLocation.vue?vue&type=script&lang=ts"
export * from "./SetLocation.vue?vue&type=script&lang=ts"
import style0 from "./SetLocation.vue?vue&type=style&index=0&id=5cf7d307&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports